module.exports = __webpack_public_path__ + "img/orange.efd0a0e3.png";